import React, { useEffect } from "react";
import "../styles/geoAndDecComp1.css";
import "../styles/womanhoodComp.css";
import Respect1 from "../assets/womanhood/IMG_5940_edited.png";
import Respect2 from "../assets/womanhood/IMG_5965_edited.png";
import Respect3 from "../assets/womanhood/IMG_5966_edited.jpg";
import Respect4 from "../assets/womanhood/2-IMG_5944_edited.png";

const WomanhoodComp11 = () => {
  useEffect(() => {
    const container = document.querySelector(".container");
    const content = document.querySelector(".scroll-content");
    const thumb = document.querySelector(".scrollbar-thumb");

    // Helper functions to disable and enable text selection
    const disableTextSelection = () => {
      document.body.style.userSelect = "none"; // Disable text selection
    };

    const enableTextSelection = () => {
      document.body.style.userSelect = ""; // Re-enable text selection
    };

    const updateThumbPosition = () => {
      const contentWidth = content.scrollWidth;
      const containerWidth = container.clientWidth;
      const scrollLeft = content.scrollLeft;

      const thumbWidth = Math.max(
        (containerWidth / contentWidth) * containerWidth,
        50
      );
      const thumbLeft = (scrollLeft / contentWidth) * containerWidth;

      thumb.style.width = `${thumbWidth}px`;
      thumb.style.left = `${thumbLeft}px`;
    };

    content.addEventListener("scroll", updateThumbPosition);
    updateThumbPosition();

    const startDrag = (e, isTouch = false) => {
      e.preventDefault(); // Add this line
      disableTextSelection();

      const startX = isTouch ? e.touches[0].clientX : e.clientX;
      const startLeft = parseFloat(thumb.style.left) || 0; // Add fallback

      const onMove = (moveEvent) => {
        moveEvent.preventDefault(); // Add this line
        const clientX = isTouch
          ? moveEvent.touches[0].clientX
          : moveEvent.clientX;
        const deltaX = clientX - startX;
        const newLeft = Math.min(
          container.clientWidth - thumb.clientWidth,
          Math.max(0, startLeft + deltaX)
        );

        thumb.style.left = `${newLeft}px`;
        content.scrollLeft =
          (newLeft / container.clientWidth) * content.scrollWidth;
      };

      const onEnd = () => {
        enableTextSelection();
        document.removeEventListener(
          isTouch ? "touchmove" : "mousemove",
          onMove
        );
        document.removeEventListener(isTouch ? "touchend" : "mouseup", onEnd);
      };

      document.addEventListener(isTouch ? "touchmove" : "mousemove", onMove, {
        passive: false,
      });
      document.addEventListener(isTouch ? "touchend" : "mouseup", onEnd);
    };

    // Create bound event handlers
    const handleMouseDown = (e) => startDrag(e, false);
    const handleTouchStart = (e) => startDrag(e, true);

    thumb.addEventListener("mousedown", handleMouseDown);
    thumb.addEventListener("touchstart", handleTouchStart);

    return () => {
      content.removeEventListener("scroll", updateThumbPosition);
      thumb.removeEventListener("mousedown", handleMouseDown);
      thumb.removeEventListener("touchstart", handleTouchStart);
    };
  }, []);

  return (
    <div className="container">
      <div className="scroll-content">
        <div className="image-container-geoAndDecComp1 times-new-roman w11">
          <div className="image-womanhoodComp11">
            <img
              src={Respect1}
              alt="Womanhood series - painting red and blue"
            />
          </div>
          <div className="image-womanhoodComp11">
            <img
              src={Respect2}
              alt="Womanhood series - The saddest sack of organs I ever did see"
            />
            <p className="image-description font14px black">
              'The saddest sack of organs I ever did see'
            </p>
          </div>
          <div className="image-womanhoodComp11">
            <img
              src={Respect3}
              alt="Womanhood series - The unwanted watchful eye of the disease of creating life"
            />
            <p className="image-description font14px black">
              'The unwanted watchful eye of the disease of creating life'
            </p>
          </div>
          <div className="image-womanhoodComp11">
            <img
              src={Respect4}
              alt="Womanhood series - The burden of carrying life"
            />
            <p className="image-description font14px black">
              'The burden of carrying life'
            </p>
          </div>
        </div>
      </div>
      <div className="custom-scrollbar w11">
        <div className="scrollbar-thumb w11">
          <span className="scrollbar-text">scroll me</span>
        </div>
      </div>
    </div>
  );
};

export default WomanhoodComp11;
